var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.429 12.635c0-2.356-1.674-3.782-3.72-3.782-.62 0-1.054.186-1.24.31.062-2.542 1.922-5.394 4.65-6.014V.235c-3.472.372-8.246 3.534-8.246 10.85 0 3.534 2.108 5.27 4.526 5.27 2.294 0 4.03-1.674 4.03-3.72Zm-10.602 0c0-2.356-1.674-3.782-3.72-3.782-.62 0-1.054.186-1.24.31.062-2.542 1.922-5.394 4.65-6.014V.235C5.045.607.271 3.769.271 11.085c0 3.534 2.108 5.27 4.526 5.27 2.294 0 4.03-1.674 4.03-3.72Z"
  })));
};
export default SvgQuotes;